import BaseApi from '@/api/Base/BaseApi'
import {
  CreatePreprocessingNodePayload,
  GetPreprocessingDataListResponse,
  PreprocessingNodeInfo,
  UpdatePreprocessingNodePayload,
  UpdatePreprocessingNodeResponse
} from '@/api/PreprocessingNode/types'

const ROOT = '/preprocessing'

export default class PreprocessingNodeApi extends BaseApi {
  createPreprocessingNode(payload: CreatePreprocessingNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post<PreprocessingNodeInfo>(`/project/${projectId}/preprocessing/create`, rest)
  }

  getPreprocessingNodeDetail(preprocessingNodeId: string) {
    return this.agent.get<PreprocessingNodeInfo>(`${ROOT}/${preprocessingNodeId}`)
  }

  updatePreprocessingNode(payload: UpdatePreprocessingNodePayload) {
    const { preprocessingNodeId, name, ...rest } = payload
    return this.agent.put<UpdatePreprocessingNodeResponse>(`${ROOT}/${preprocessingNodeId}`, { ...rest, name: name?.trim() })
  }

  deletePreprocessingNode(preprocessingNodeId: string) {
    return this.agent.delete(`${ROOT}/${preprocessingNodeId}`)
  }

  getPreprocessingDataList(preprocessingNodeId: string) {
    return this.agent.get<GetPreprocessingDataListResponse>(`${ROOT}/${preprocessingNodeId}/data-list`)
  }
}
